import { ModuleRunsView } from './ModuleRunsView';

/** Модуль «БДДС и платёжный календарь» (М4): движение денежных средств по
 *  статьям, балансы счетов, скользящий платёжный календарь с детектом кассовых
 *  разрывов. Механика прогонов — см. ModuleRunsView. */
export function CashflowReport() {
  return <ModuleRunsView moduleId="cashflow" />;
}
